import React, {FunctionComponent, useState} from "react";
import WizardStep from "../../WizardStep";
import statusSummary from "../../../../images/Progress/progress_zusammenfassung.svg";
import {
    Box,
    Divider,
    makeStyles, useMediaQuery
} from "@material-ui/core";
import ContactAndPickUpSummary from "./ContactAndPickUpSummary";
import SummarySlider from "./SummarySlider";
import DisposalSummaryItem from "./DisposalSummaryItem";
import AgbCheckBox from "../../../../commonComponents/AgbCheckBox";
import {useSelector} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {useApi} from "../../../../apiClient";
import {I18n} from "aws-amplify";
import {NavigationProps} from "../../../slideRouter/navigationHook";
import theme from "../../../../theme";
import {EnhancedDisposal} from "../../../state/disposalSlice";
import plusIcon from "../../../../images/Icons/plus-button_icn.svg";
import SvgButton from "../../../../commonComponents/SvgButton";
import {Step} from "../../../WizardMap";
import Text from "../../../../commonComponents/Text";

const useStyles = makeStyles(theme => ({
    agbContainer: {
        marginTop: 40,
        [theme.breakpoints.down("xs")]: {
            marginTop: 20,
            marginBottom: 40
        }
    }
}));

const StepSummary: FunctionComponent<NavigationProps> = ({gotoPrevSlide, jumpTo}) => {

    const classes = useStyles();

    const {sendLead, ApiProgress} = useApi();

    const isXs = useMediaQuery(theme.breakpoints.down("xs"));

    const {contact, disposal: {disposals}} = useSelector((state: RootState) => state);

    const [agbChecked, setAgbChecked] = useState<boolean>(false);

    const handleNextClick = () => sendLead();

    const NewDisposalButton = () => (
        <Box padding={1} minHeight={127}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"}>
                <Text value={"Produkt hinzufügen"} size={13}/>
                <SvgButton svg={plusIcon} onClick={() => jumpTo(Step.OBJECT_TYPE)} style={{marginTop: 10}}/>
            </Box>
        </Box>);

    const renderDisposals = (disposals: EnhancedDisposal[]) => {
        const length = disposals.length;
        if (length >= 2) {
            return (
                <SummarySlider>
                    {disposals.map((disposal, index) =>
                        <DisposalSummaryItem
                            key={index}
                            disposal={disposal}
                            jumpTo={jumpTo}
                        />)}
                </SummarySlider>
            );
        } else if (length === 1) {
            return disposals.map((disposal, index) => (
                <DisposalSummaryItem
                    disposal={disposal}
                    key={index}
                    jumpTo={jumpTo}
                />));
        } else {
            return <NewDisposalButton/>;
        }
    };

    return (
        <WizardStep
            title={"Zusammenfassung"}
            icon={statusSummary}
            nextButton
            nextButtonText={I18n.get("common").send}
            nextButtonDisabled={!agbChecked || disposals.length < 1}
            onBackClick={gotoPrevSlide}
            backButton
            onNextClick={handleNextClick}
        >
            <Box display="flex" flexDirection="column" alignItems={"center"} justifyContent={"center"}>
                <Box marginBottom={5} display={{xs: "none", sm: "block"}}>
                    {renderDisposals(disposals)}
                </Box>
                <Box marginBottom={5} display={{xs: "block", sm: "none", alignItems: "center"}}>
                    {disposals.length > 0
                        ? disposals.map((disposal, index) =>
                            <DisposalSummaryItem
                                key={index}
                                disposal={disposal}
                                style={{marginBottom: 16}}
                                jumpTo={jumpTo}
                            />)
                        : <NewDisposalButton/>}
                </Box>
                <Box width={isXs || (disposals.length > 1 && contact.pickUp) ? "100%" : 260} marginBottom={5}>
                    <Divider variant="middle"/>
                </Box>
                <ContactAndPickUpSummary
                    contact={contact}
                    jumpTo={jumpTo}
                />
                <Box className={classes.agbContainer}>
                    <AgbCheckBox checked={agbChecked} toggleChecked={() => setAgbChecked(prevState => !prevState)}/>
                </Box>
                <ApiProgress/>
            </Box>
        </WizardStep>
    );
};

export default StepSummary;

